<template>
  <div class="dashboard-editor-container">
    <el-row :gutter="32">
      <el-col :sm="24" :lg="18">
        <el-row>
          <el-col class="hidden-xs-only">
            <div class="wj_mail_top">
              <el-col :xs="24" :sm="2">
                <div class="header_avater">
                  <el-image :src="header_url"></el-image>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12">
                <div class="header_content">
                  <div class="header_title">{{ getMorning() }}{{ current_user.realname }}，祝你开心每一天！</div>
                  <div v-if="current_user.prev_login_time" class="header_desc">上次登录时间【{{ current_user.prev_login_time }}】</div>
                </div>
              </el-col>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :sm="24" :lg="6">
        <el-row>
          <div class="wj_mail_right">
            <div class="tel_left"><i class="el-icon-phone-outline"></i></div>
            <div class="tel_content">
              <div class="tel_title">在线客服</div>
              <div>0471-4953016</div>
            </div>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <!--    <el-row v-if="current_user.is_system==1" :gutter="20">-->
    <!--      <el-col>-->
    <!--        <panel-group ref="panel1" />-->
    <!--      </el-col>-->
    <!--    </el-row>-->
  </div>
</template>

<script>
// import 'element-ui/lib/theme-chalk/display.css'
// import PanelGroup from './components/PanelGroup'

import {
  mapGetters
} from 'vuex'
export default {
  name: 'DashboardAdmin',
  components: {
    // PanelGroup
  },
  filters: {

  },
  data() {
    return {
      header_url: '/header.png',
      qrcode_url: '/qrcode-wechat.png'
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  created() {
  },
  methods: {
    // 获取时间段
    getMorning() {
      let str = ''
      const now = new Date()
      const hour = now.getHours()
      if (hour < 6) {
        str = '凌晨好！'
      } else if (hour < 9) {
        str = '早上好！'
      } else if (hour < 12) {
        str = '上午好！'
      } else if (hour < 14) {
        str = '中午好！'
      } else if (hour < 17) {
        str = '下午好！'
      } else if (hour < 19) {
        str = '傍晚好！'
      } else if (hour < 22) {
        str = '晚上好！'
      } else {
        str = '夜里好！'
      }
      return str
    }
  }
}

</script>

<style lang="scss">
.wj_mail_top {
  width: 100%;
  min-height: 100px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.1);
  margin-bottom: 16px;
  padding: 5px 10px;

  .header_avater{
    width: 75px;
    height: 75px;
    float: left;
    margin-left: 5px;
    margin-top: 7px;
  }
  .header_content{
    width: 100%;
    float: left;
    margin-top: 10px;
    margin-left: 20px
  }
  .header_content div{
    margin-bottom: 12px;
    display: block;
    line-height: 30px;
  }
  .header_content_left{
    float: right;
  }
  .header_content_right{
    width: 95px;
    float: right;
    span{
      display: inline-block;
      width: 73px;
      background: #409EFF;
      height: 73px;
      color: #ffffff;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
      padding: 10px;
      border-radius: 3px;
      cursor: pointer;
    }
  }
  .header_title{
    font-weight: 600;
    font-size: 20px;
    line-height: 34px;
    color: #909399;
  }
  .header_desc {
    line-height: 22px;
    color: rgba(0, 0, 0, .45);
    font-size: 14px;
  }
}
.wj_mail_right {
  width: 100%;
  min-height: 100px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,0.1);
  margin-bottom: 32px;
  padding: 5px 10px;
  color: #909399;

  .news-heading{
    font-size: 20px;
    line-height: 30px;
    font-weight: 100;
    padding: 10px 0px;
    border-bottom: 1px solid #dde9ed;

    i {
      padding: 0 10px;
    }
  }
  .news-list{
    padding-left: 20px;
    padding-top: 8px;
  }
  .news-list li{
    color: #5b9bd1;
    font-size: 16px;
    line-height: 28px;
    a{
      color: #909399;
      font-size: 15px;
    }
    a:hover{
      color: #409EFF;
    }
  }
  .tel_left{
    width: 75px;
    height: 75px;
    float: left;
    margin-left: 10px;
    margin-top: 15px;

    i {
      font-size: 60px;
    }
  }
  .tel_content{
    float: left;
    display: block;
    font-size: 16px;
    line-height: 30px;
    padding: 13px 10px;

    .tel_title{
      font-size: 20px;
      font-weight: 600;
      line-height: 34px;
    }
  }
  .qrcode{
    width: 180px;
    height: 180px;
    margin: 15px auto;
  }
  .qrcode_title{
    text-align: center;
    margin-bottom: 15px;

    span{
      color: #409EFF;
    }
  }
}
.box-card{
  margin: 10px 0px;
}
.dashboard-editor-container {
  padding: 32px;
  position: relative;

  .chart-title{
    background: #fff;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;
    padding: 15px 20px;
    font-weight: 400;
    font-size: 14px;
    span::before{
      content: "";
      display: inline-block;
      width: 3px;
      height: 12px;
      position: relative;
      top: 1px;
      background: #6190E8;
      margin-right: 10px;
    }
  }
  .chart-wrapper {
    background: #fff;
    border-radius: 5px;
    min-height: 416px;
    padding: 16px 16px 0;
    margin-bottom: 32px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1)
  }
}

</style>
